import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { COMPANIES_ACTIONS } from "../../../redux/companies/actions";
import CompaniesForm from "../../forms/CompaniesForm";
import {
  companiesErrors,
  companiesUpdating,
  selectActiveCompany
} from "../../../redux/companies/selectors";

class CompaniesEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {}
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    updateRequest: PropTypes.func,
    match: PropTypes.object,
    venues: PropTypes.array,
    loadCompany: PropTypes.func,
    company: PropTypes.object,
    ajaxErrors: PropTypes.object,
    resetErrors: PropTypes.func,
    isUpdating: PropTypes.bool,
    "match.params": PropTypes.object,
    "match.params.id": PropTypes.string
  };

  UNSAFE_componentWillMount() {
    this.props.loadCompany(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.resetErrors();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      company: nextProps.company
    });
  }

  _handleSubmit(values) {
    const data = {
      name: values.name,
      email: values.email,
      telephone: values.telephone,
      addressLine1: values.address,
      city: values.city,
      zip: values.postal_code,
      country: values.country,
      vat: values.vat,
      type: values.type,
      accountingCustomerCode: values.accountingCustomerCode
    };

    this.props.updateRequest(values.id, data);
  }

  render() {
    const breadcrumbs = [
      {
        title: "Companies",
        to: "/admin/companies"
      }
    ];

    const { company } = this.state;
    const { venues, ajaxErrors, isUpdating } = this.props;

    return [
      <AdminSubHeader
        title="Edit Company"
        key="subheader"
        breadcrumbs={breadcrumbs}
      />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Company Info</h3>
                  </div>
                </div>
              </div>
              <CompaniesForm
                onSubmit={this._handleSubmit}
                venues={venues}
                formSubmitting={isUpdating}
                company={company}
                ajaxErrors={ajaxErrors}
              />
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapStateToProps = function(state, props) {
  return {
    company: selectActiveCompany(state),
    isUpdating: companiesUpdating(state),
    ajaxErrors: companiesErrors(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateRequest: (id, values) =>
    dispatch(COMPANIES_ACTIONS.updateRequest(id, values)),
  loadCompany: id => dispatch(COMPANIES_ACTIONS.loadRequest(id)),
  resetErrors: () => dispatch(COMPANIES_ACTIONS.resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesEdit);
